import { authFetch } from "./authProvider";

const SERVICE_URL = "wash-inventory-service/v2/organizations/:orgId";
export const addWashInventory = async (washData, orgId) => {
  let url =
    SERVICE_URL.replace(":orgId", orgId) +
    "/accounts/" +
    washData.accountId +
    "/locations/" +
    washData.locationNumber +
    "/wash-inventory";
  return await authFetch("post", url, washData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error);
      return error.response;
    });
};

export const addNote = async (noteData, orgId) => {
  let url =
    SERVICE_URL.replace(":orgId", orgId) +
    "/accounts/" +
    noteData.accountId +
    "/locations/" +
    noteData.locationNumber +
    "/wash-note";
  return await authFetch("post", url, noteData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error);
      return error.response;
    });
};

export const updateNote = async (noteData, orgId) => {
  let url =
    SERVICE_URL.replace(":orgId", orgId) +
    "/accounts/" +
    noteData.accountId +
    "/wash-notes/" +
    noteData.id;
  return await authFetch("patch", url, noteData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error);
      return error.response;
    });
};

export const getAllWashInventory = async (
  accountId,
  leadId,
  startTime,
  endTime,
  orgId,
) => {
  let url =
    SERVICE_URL.replace(":orgId", orgId) +
    "/wash-inventories/accounts/" +
    accountId +
    "/leads/" +
    leadId +
    "/startTime/" +
    startTime +
    "/endTime/" +
    endTime;
  return await authFetch("get", url, {})
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error.response);
      return error.response;
    });
};

export const getWashInventoryWithinDays = async (days, orgId) => {
  let url =
    SERVICE_URL.replace(":orgId", orgId) +
    "/wash-inventories/last-wash-for-fleets/within/" +
    days;
  return await authFetch("get", url, {})
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error.response);
      return error.response;
    });
};

export const getAllWashNotes = async (
  orgId,
  accountId,
  locationNumber,
  leadId,
  startTime,
  endTime,
) => {
  let url =
    SERVICE_URL.replace(":orgId", orgId) +
    "/accounts/" +
    accountId +
    "/locations/" +
    locationNumber +
    "/leads/" +
    leadId +
    "/wash-notes/startTime/" +
    startTime +
    "/endTime/" +
    endTime;
  return await authFetch("get", url, {})
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error.response);
      return error.response;
    });
};

export const addAcknowledgement = async (acknowledgementData, orgId) => {
  let url =
    SERVICE_URL.replace(":orgId", orgId) +
    "/accounts/" +
    acknowledgementData.accountId +
    "/locations/" +
    acknowledgementData.locationNumber +
    "/leads/" +
    acknowledgementData.leadId +
    "/acknowledgement";
  return await authFetch("post", url, {
    acknowledgementDate: acknowledgementData.acknowledgementDate,
  })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error);
      return error.response;
    });
};

export const getInstructionAcknowledgements = async (orgId, date) => {
  let url =
    SERVICE_URL.replace(":orgId", orgId) +
    "/instruction-acknowledgements?acknowledgementDate=" +
    date;

  return await authFetch("get", url, {})
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error.response);
      return error.response;
    });
};
